import * as bi from 'react-bootstrap-icons';
import {
  ClientPassengerDocumentStatus,
  IClientTicketFullPassenger,
  IClientTicketFullTrip,
} from '@bustickus/models-client';
import { Flex } from 'components';
import { useState } from 'react';
import { SpoilerCard } from 'shared/components';
import { DataRow } from '..';
import { dateOnlyFormat } from 'common/helpers';

interface IProps {
  passenger: IClientTicketFullPassenger;
  trip: IClientTicketFullTrip | null | undefined;
}

function PassengerCard(props: IProps) {
  const [open, setOpen] = useState<boolean>(false);

  return (
    <SpoilerCard
      title='Данные пассажира'
      open={open}
      onOpenClick={() => setOpen(!open)}
    >
      <Flex
        direction='column'
        gap={10}
      >
        <Flex direction='column'>
          <DataRow
            title={props.passenger.name}
            icon={<bi.Person />}
          />
          <DataRow
            icon={<bi.Calendar />}
            title='Дата рождения:'
            value={dateOnlyFormat(props.passenger.birthDate, 'DD MMMM YYYY')}
          />
          <DataRow
            icon={props.passenger.gender === 'male' ? <bi.GenderMale /> : <bi.GenderFemale />}
            title='Пол:'
            value={props.passenger.gender === 'male' ? 'Мужской' : 'Женский'}
          />
        </Flex>
        {props.trip != null && (
          <Flex direction='column'>
            {props.trip.documents.passport && (
              <DataRow
                icon={<bi.Passport />}
                title='Паспорт РФ'
                value={props.passenger.passport ? 'Указан' : 'Не указан'}
              />
            )}

            {props.trip.documents.foreignPassport && (
              <DataRow
                icon={<bi.Passport />}
                title='Заграничный паспорт'
                value={props.passenger.foreignPassport ? 'Указан' : 'Не указан'}
              />
            )}
            {props.trip.documents.visaNames.map((visa) => (
              <DataRow
                key={visa}
                icon={<bi.Passport />}
                title={visa}
                value={props.passenger.visas.includes(visa) ? 'Указана' : 'Не указана'}
              />
            ))}
          </Flex>
        )}
      </Flex>
    </SpoilerCard>
  );
}

function getDocumentString(document: ClientPassengerDocumentStatus | null | undefined): React.ReactNode {
  if (document == null || document === 'none') {
    return <span>Отсутствует</span>;
  }

  if (document === 'ok') {
    return <span>Указан</span>;
  }

  if (document === 'expired') {
    return <span>Просрочен</span>;
  }

  return <span>Статус неизвестен</span>;
}

export default PassengerCard;
